
import { useState } from "react";
import styles from "./wishlist.module.css";
import WishListCard from "./WishListCard/WishListCard";
import {
  Loader,
  Pagination,
} from "../../../../components/shared/index";
import {
  useGetWishLists,
  useRemoveWishList,
} from "../../../../queries/useWishListQuery";
import { getImageUrl } from "../../../../lib/get-image";
import { useAddToCart } from "../../../../queries/useCartQuery";
import toast from "react-hot-toast";

const WishList = () => { 
  const {
    data: wishListItems,
    isPending,
    error,
  } = useGetWishLists();

  const { mutate: addToCart } = useAddToCart();

  const [loadingItemId, setLoadingItemId] = useState(null);
  const { mutate: removeWish } = useRemoveWishList();

  const [currentPage, setCurrentPage] = useState(1);

  const per_page = 5;

  if (isPending) {
    return <Loader title="Loading wishlist..." />;
  }

  if (error) {
    return (
      <div
        style={{
          padding: "2rem",
          textAlign: "center",
          color: "red",
        }}
      >
        <p>Failed to load wishlist.</p>
        <p>{error?.message || "Something went wrong"}</p>
      </div>
    );
  }

  /*
   * API structure:
   *
   * item
   *   └── product
   *        └── variant_items
   *             └── [0]
   *
   * qty, sku, price and offer_price
   * are inside variant_items.
   */

  const formattedWishList =
    wishListItems
      ?.map((item) => {
        const product = item?.product;

        // Get first available variant
        const variant = product?.variant_items?.[0];

        if (!product || !variant) {
          return null;
        }

        const originalPrice = Number(variant?.price || 0);
        const offerPrice = Number(variant?.offer_price || 0);
        const quantity = Number(variant?.qty || 0);

        const hasOffer =
          offerPrice > 0 && offerPrice < originalPrice;

       return {
  id: item?.id,

  productId: product?.id,

  // IMPORTANT: variant ID required by cart API
  productVariantItemId: variant?.id,

  productQuantity: quantity,

          productSlug: product?.slug,

          image: getImageUrl(product?.thumb_image),

          title: product?.name || "Product",

          sku: variant?.sku || "-",

          size: variant?.size || "-",

          colorName: variant?.color_name || "-",

          price: hasOffer ? offerPrice : originalPrice,

          oldPrice: hasOffer ? originalPrice : null,

          offer: hasOffer
            ? Math.round(
                ((originalPrice - offerPrice) / originalPrice) * 100
              )
            : 0,
        };
      })
      .filter((item) => item !== null)
      .filter((item) => item.productQuantity > 0) || [];

  const handleAddToCart = (item) => {
  if (!item?.productId) {
    toast.error("Product ID missing");
    return;
  }

  if (!item?.productVariantItemId) {
    toast.error("Product variant ID missing");
    return;
  }

  setLoadingItemId(item.id);

  addToCart(
    {
      product_id: item.productId,
      product_variant_item_id: item.productVariantItemId,
      quantity: 1,
    },
    {
      onSuccess: () => {
        toast.success(`item added to cart`);
      },

      onError: (error) => {
        console.error("ADD TO CART ERROR:", error);

        toast.error(
          error?.response?.data?.detail?.[0]?.msg ||
            "Failed to add item to cart"
        );
      },

      onSettled: () => {
        setLoadingItemId(null);
      },
    }
  );
};

  const indexOfLast = currentPage * per_page;
  const indexOfFirst = indexOfLast - per_page;

  const currentItems = formattedWishList.slice(
    indexOfFirst,
    indexOfLast
  );

  return (
    <div className={styles.wrapper}>
      <div className={styles.listWrapper}>
        {formattedWishList.length === 0 ? (
          <div className={styles.emptyWishlist}>
            <div className={styles.emptyWishlistIcon}>♡</div>

            <h2 className={styles.emptyWishlistTitle}>
              Empty Wishlist
            </h2>

            <p className={styles.emptyWishlistText}>
              You have no items in your wishlist. Start adding!
            </p>
          </div>
        ) : (
          currentItems.map((item) => (
           <WishListCard
  key={item.id}
  item={item}
  isCartPending={loadingItemId === item.id}
  onAddToCart={() => handleAddToCart(item)}
  onRemove={() => removeWish(item.id)}
/>
          ))
        )}
      </div>

      {formattedWishList.length > per_page && (
        <div className={styles.paginationWrapper}>
          <Pagination
            currentPage={currentPage}
            total={formattedWishList.length}
            per_page={per_page}
            handlePageChange={setCurrentPage}
          />
        </div>
      )}
    </div>
  );
};

export default WishList;

